<div [attr.data-testid]="'video-container'">
  <a [style.padding-bottom.%]="imageHeight" [attr.data-testid]="'video-link'">
    @if (data.previewUrl) {
      <img
        [src]="data.previewUrl | imageType"
        alt="previewUrl"
        [attr.data-testid]="'video-preview-image'"
        />
    }
  </a>
</div>
